import { bindActionCreators } from "redux";
import { call, put, take } from "redux-saga/effects";

import * as apiCaller from "./../../api/apiCaller";

export const GET_LIST_KNOWLEDGE_BASE = "GET_LIST_KNOWLEDGE_BASE";
export const GET_LIST_KNOWLEDGE_BASE_ERROR = "GET_LIST_KNOWLEDGE_BASE_ERROR";
export const GET_LIST_KNOWLEDGE_BASE_SUCCESS =
  "GET_LIST_KNOWLEDGE_BASE_SUCCESS";

export const COUNT_LIST_KNOWLEDGE_BASE = "COUNT_LIST_KNOWLEDGE_BASE";
export const COUNT_LIST_KNOWLEDGE_BASE_ERROR =
  "COUNT_LIST_KNOWLEDGE_BASE_ERROR";
export const COUNT_LIST_KNOWLEDGE_BASE_SUCCESS =
  "COUNT_LIST_KNOWLEDGE_BASE_SUCCESS";

export const ADD_NEW_KNOWLEDGE_BASE = "ADD_NEW_KNOWLEDGE_BASE";
export const ADD_NEW_KNOWLEDGE_BASE_ERROR = "ADD_NEW_KNOWLEDGE_BASE_ERROR";
export const ADD_NEW_KNOWLEDGE_BASE_SUCCESS = "ADD_NEW_KNOWLEDGE_BASE_SUCCESS";

export const EDIT_A_KNOWLEDGE_BASE = "EDIT_A_KNOWLEDGE_BASE";
export const EDIT_A_KNOWLEDGE_BASE_SUCCESS = "EDIT_A_KNOWLEDGE_BASE_SUCCESS";
export const EDIT_A_KNOWLEDGE_BASE_ERROR = "EDIT_A_KNOWLEDGE_BASE_ERROR";

export const DELETE_A_KNOWLEDGE_BASE = "DELETE_A_KNOWLEDGE_BASE";
export const DELETE_A_KNOWLEDGE_BASE_SUCCESS =
  "DELETE_A_KNOWLEDGE_BASE_SUCCESS";
export const DELETE_A_KNOWLEDGE_BASE_ERROR = "DELETE_A_KNOWLEDGE_BASE_ERROR";

export const SEARCH_KNOWLEDGE_BASE = "SEARCH_KNOWLEDGE_BASE";
export const SEARCH_KNOWLEDGE_BASE_SUCCESS = "SEARCH_KNOWLEDGE_BASE_SUCCESS";
export const SEARCH_KNOWLEDGE_BASE_ERROR = "SEARCH_KNOWLEDGE_BASE_ERROR";

/**
 * Reducer
 */

const initialState = {
  knowledgeBases: [],
  error: false,
  count: 0,
  loading: false,
  knowledgeBase: {},
};

export const knowledgeBasesReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_KNOWLEDGE_BASE:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_KNOWLEDGE_BASE_SUCCESS:
      return {
        ...state,
        loading: false,
        knowledgeBases: action.payload,
      };
    case GET_LIST_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };

    //count list
    case COUNT_LIST_KNOWLEDGE_BASE:
      return {
        ...state,
      };
    case COUNT_LIST_KNOWLEDGE_BASE_SUCCESS:
      return {
        ...state,
        count: action.payload,
      };
    case COUNT_LIST_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //add new
    case ADD_NEW_KNOWLEDGE_BASE:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_KNOWLEDGE_BASE_SUCCESS:
      return {
        ...state,
        loading: false,
        knowledgeBase: action.payload,
      };
    case ADD_NEW_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //edit
    case EDIT_A_KNOWLEDGE_BASE:
      return {
        ...state,
        loading: true,
      };
    case EDIT_A_KNOWLEDGE_BASE_SUCCESS: {
      const newItems = state.knowledgeBases.filter(
        (item) => item.id !== action.data.id
      );
      return {
        ...state,
        loading: false,
        newItems,
      };
    }
    case EDIT_A_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    ///delete
    case DELETE_A_KNOWLEDGE_BASE:
      return {
        ...state,
        loading: true,
      };
    case DELETE_A_KNOWLEDGE_BASE_SUCCESS:
      return {
        ...state,
        loading: false,
        knowledgeBase: action.payload,
      };
    case DELETE_A_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        loading: true,
        error: action.error,
      };
    //search knowledgebase
    case SEARCH_KNOWLEDGE_BASE:
      return {
        ...state,
      };
    case SEARCH_KNOWLEDGE_BASE_SUCCESS:
      return {
        ...state,
        knowledgeBase: action.payload,
      };
    case SEARCH_KNOWLEDGE_BASE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListKnowledgeBase = (order, limit, skip, where) => ({
  type: GET_LIST_KNOWLEDGE_BASE,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const countListKnowledgeBase = (where) => ({
  type: COUNT_LIST_KNOWLEDGE_BASE,
  data: {
    where,
  },
});

export const addNewKnowledgeBase = (title, icon, description, tags) => ({
  type: ADD_NEW_KNOWLEDGE_BASE,
  data: {
    title,
    icon,
    description,
    tags,
  },
});

export const editKnowledgeBase = (id, title, icon, description, tags) => ({
  type: EDIT_A_KNOWLEDGE_BASE,
  data: {
    id,
    title,
    icon,
    description,
    tags,
  },
});

export const deleteKnowledgeBase = (id) => ({
  type: DELETE_A_KNOWLEDGE_BASE,
  data: {
    id,
  },
});

export const searchKnowledgeBase = (tags) => ({
  type: SEARCH_KNOWLEDGE_BASE,
  data: {
    tags,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListKnowledgeBase,
      countListKnowledgeBase,
      addNewKnowledgeBase,
      editKnowledgeBase,
      deleteKnowledgeBase,
      searchKnowledgeBase,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListKnowledgeBaseApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/knowledge-base", {
    order,
    limit,
    skip,
    ...where,
  });
};

const countListKnowledgeBaseApi = (where) => {
  return apiCaller.getData("/mini-crm/knowledge-base/count", { ...where });
};
const addNewKnowledgeBaseApi = (title, icon, description, tags) => {
  return apiCaller.post("/mini-crm/knowledge-base", {
    title,
    icon,
    description,
    ...tags,
  });
};
const editKnowledgeBaseApi = (id, title, icon, description, tags) => {
  return apiCaller.put(`/mini-crm/knowledge-base/${id}`, {
    title,
    icon,
    description,
    ...tags,
  });
};
const deleteKnowledgeBaseApi = (id) => {
  return apiCaller.del(`/mini-crm/knowledge-base/${id}`);
};
const searchKnowledgeBaseApi = (tags) => {
  return apiCaller.getLogs("/knowledge-base/getUserTreeView/", { tags });
};
/**
 * sagas
 */

export const getListKnowledgeBaseFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_KNOWLEDGE_BASE);
    try {
      const res = yield call(
        getListKnowledgeBaseApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};

export const countKnowledgeBaseFlow = function* () {
  while (true) {
    const action = yield take(COUNT_LIST_KNOWLEDGE_BASE);
    try {
      const res = yield call(countListKnowledgeBaseApi, action.data.where);
      yield put({
        type: COUNT_LIST_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: COUNT_LIST_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};

export const addNewKnowledgeBaseFlow = function* () {
  while (true) {
    const {
      data: { title, icon, description, tags },
    } = yield take(ADD_NEW_KNOWLEDGE_BASE);
    try {
      const res = yield call(
        addNewKnowledgeBaseApi,
        title,
        icon,
        description,
        tags
      );
      yield put({
        type: ADD_NEW_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: ADD_NEW_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};

export const editKnowledgeBaseFlow = function* () {
  while (true) {
    const {
      data: { id, title, icon, description, tags },
    } = yield take(EDIT_A_KNOWLEDGE_BASE);
    try {
      const res = yield call(
        editKnowledgeBaseApi,
        id,
        title,
        icon,
        description,
        tags
      );
      yield put({
        type: EDIT_A_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: EDIT_A_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};

export const deleteKnowledgeBaseFlow = function* () {
  while (true) {
    const action = yield take(DELETE_A_KNOWLEDGE_BASE);
    try {
      const res = yield call(deleteKnowledgeBaseApi, action.data.id);
      yield put({
        type: DELETE_A_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: DELETE_A_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};

export const searchKnowledgeBaseFlow = function* () {
  while (true) {
    const action = yield take(SEARCH_KNOWLEDGE_BASE);
    try {
      const res = yield call(searchKnowledgeBaseApi, action.data.tags);
      yield put({
        type: SEARCH_KNOWLEDGE_BASE_SUCCESS,
        payload: { ...res.payload },
      });
    } catch (error) {
      yield put({ type: SEARCH_KNOWLEDGE_BASE_ERROR, error });
    }
  }
};
